import { useCallback, useMemo, useState } from 'react';
import { useTheme, Collapse, Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { StoreRootState } from 'services/store/types';
import LoadingButton from 'components/LoadingButton';
import general from 'services/locales/en/general';
import { userService } from 'services/api';

const EmailConfirmationBar = () => {
  const theme = useTheme();
  const { t } = useTranslation();

  const [isLoading, setIsLoading] = useState(false);

  const userEmail = useSelector((store: StoreRootState) => store.user.email);
  const useConfirmedEmail = useSelector(
    (store: StoreRootState) => store.user.emailConfirmed
  );

  const isHidden = useMemo(() => {
    if (!userEmail) {
      return true;
    }
    return useConfirmedEmail;
  }, [userEmail, useConfirmedEmail]);

  const handleOnClick = useCallback(() => {
    setIsLoading(true);
    userService.resendConfirmationEmail().finally(() => {
      setIsLoading(false);
    });
  }, []);

  return (
    <Collapse in={!isHidden}>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignContent: 'center',
          alignItems: 'center',
          width: '100%',
          minHeight: theme.spacing(6.75),
          padding: theme.spacing(1.5, 2),
          background: theme.palette.secondary.dark,
        }}
      >
        <Typography sx={{ fontWeight: 500 }}>
          {t(general.emailConfirmation.bar.description)}
        </Typography>
        <LoadingButton
          onClick={handleOnClick}
          loading={isLoading}
          variant="outlined"
        >
          {t(general.emailConfirmation.action.resend)}
        </LoadingButton>
      </Box>
    </Collapse>
  );
};

export default EmailConfirmationBar;
